import {
  type AuthState,
  type AuthStore,
  type ConvexAuthClient,
  createConvexAuthStore,
  signedOutBy as signedOutByIn,
  useAuthState as useAuthStateIn,
  wireConvexAuth as wireConvexAuthIn,
} from "@bindery/auth-consumer/react";

export type { AuthState, AuthStore };

export const createAuthStore = createConvexAuthStore;

export const authStore = createAuthStore();

export function wireConvexAuth(
  client: ConvexAuthClient,
  onChange?: (isAuthenticated: boolean) => void,
  store: AuthStore = authStore,
): void {
  wireConvexAuthIn(client, store, onChange);
}

export function useAuthState(store: AuthStore = authStore): AuthState {
  return useAuthStateIn(store);
}

export function signedOutBy(
  error: unknown,
  store: AuthStore = authStore,
): boolean {
  return signedOutByIn(error, store);
}
